export default __webpack_public_path__ + "static/media/beaches_icon.580952b5.svg";